import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import { ArrowLeft, Clock, Users, FileText, BarChart, Shield, Zap, Calendar } from 'lucide-react';

export const InnovaPunchPage = () => {
  const features = [
    {
      icon: <Clock className="w-6 h-6" />,
      title: 'Pointage en temps réel',
      description: 'Enregistrement instantané des heures d\'entrée et de sortie de vos employés'
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: 'Gestion multi-employés',
      description: 'Gérez facilement les feuilles de temps de toute votre équipe'
    },
    {
      icon: <FileText className="w-6 h-6" />,
      title: 'Feuilles de temps détaillées',
      description: 'Rapports complets avec heures travaillées, pauses et heures supplémentaires'
    },
    {
      icon: <BarChart className="w-6 h-6" />,
      title: 'Rapports et analyses',
      description: 'Visualisez les données avec des graphiques et tableaux détaillés'
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: 'Sécurisé et conforme',
      description: 'Conforme aux normes du travail et protection des données'
    },
    {
      icon: <Zap className="w-6 h-6" />,
      title: 'Intégration paie',
      description: 'Export direct vers vos logiciels de paie préférés'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-blue-50">
      <Header />
      
      <main className="max-w-6xl mx-auto px-4 py-20">
        <Button
          onClick={() => window.location.href = '/'}
          variant="ghost"
          className="mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Button>

        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="inline-block p-6 bg-gradient-to-br from-orange-600 to-orange-800 rounded-full mb-6">
            <Calendar className="w-16 h-16 text-white" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-orange-700 to-blue-600 bg-clip-text text-transparent">
            Innova-Punch
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
            La solution complète pour la gestion des feuilles de temps et le tracking des heures travaillées
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-orange-600 to-orange-800 rounded-lg flex items-center justify-center mb-4 text-white">
                {feature.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Benefits Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
            Pourquoi choisir Innova-Punch?
          </h2>
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-white font-bold">✓</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Gain de temps considérable</h3>
                <p className="text-gray-600">Automatisez le calcul des heures et éliminez les erreurs manuelles</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-white font-bold">✓</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Conformité garantie</h3>
                <p className="text-gray-600">Respectez les normes du travail avec nos rapports conformes</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-white font-bold">✓</span>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-1">Accessible partout</h3>
                <p className="text-gray-600">Application web et mobile pour pointer de n'importe où</p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-orange-600 to-blue-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Prêt à simplifier la gestion de vos heures?
          </h3>
          <p className="mb-6 text-lg">
            Contactez-nous pour une démonstration gratuite d'Innova-Punch
          </p>
          <Button
            onClick={() => window.location.href = '/#contact'}
            className="bg-white text-orange-700 hover:bg-orange-50 px-8 py-6 text-lg"
          >
            Demander une démo
          </Button>
        </div>
      </main>

      <Footer />
    </div>
  );
};
